<app-alert></app-alert>
<div class="container-fluid mainContainer p-md-0">
  <app-personality-stepper></app-personality-stepper>
</div>
